/** Sync the offline queue to the submission API when connectivity permits. */
import { listQueue, updateQueued } from "./db";

export interface SyncResult {
  attempted: number;
  synced: number;
  rejected: number;
  offline: boolean;
}

export async function syncQueue(baseUrl = ""): Promise<SyncResult> {
  const items = (await listQueue()).filter((q) => q.syncState === "PENDING");
  const result: SyncResult = {
    attempted: items.length,
    synced: 0,
    rejected: 0,
    offline: false,
  };
  for (const item of items) {
    try {
      const res = await fetch(`${baseUrl}/api/v1/daily-returns`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(item.signed),
      });
      const body = await res.text();
      if (res.ok) {
        item.syncState = "SYNCED";
        result.synced++;
      } else {
        // Rejection is a permanent verdict from the verifying server —
        // the return must be corrected and re-filed as a new version.
        item.syncState = "REJECTED";
        result.rejected++;
      }
      item.serverResponse = body;
      await updateQueued(item);
    } catch {
      // network failure — stay PENDING, try again later
      result.offline = true;
      break;
    }
  }
  return result;
}
